import { ref } from 'vue';

export const theme = ref<'default' | 'pocket-pills'>('default');
export const enableIntercom = ref(true);
export const enableAveeLogo = ref(true);
export const enableCurvedButton = ref(false);
export const enableSwitchingUser = ref(true);
export const alternativeSuccessURL = ref<Nullable<string>>(null);
export const alternativeFailureURL = ref<Nullable<string>>(null);